export const GET_CART_REQUEST = "GET_CART_REQUEST"
export const GET_CART_SUCCESS = "GET_CART_SUCCESS"
export const GET_CART_FALIURE = "GET_CART_FALIURE"


export const DELETE_CART_DATA = "DELETE_CART_DATA"
